module.exports = __webpack_public_path__ + "static/Jacque-50ff7faaffbaafe2343a633844d57009.png";